import React from "react";
import { kebabCase } from "lodash";
import { Helmet } from "react-helmet";
import { Link, graphql } from "gatsby";
import Layout from "../../components/Layout";

const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout>
    <section className="section tags-index-page">
      <Helmet title={`Tags | ${title}`} />
      <div className="container">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <header className="tags-index-hero">
              <p className="tags-index-kicker">Navegacion por temas</p>
              <h1 className="title is-size-3 is-size-4-mobile is-bold-light">
                Etiquetas
              </h1>
              <p className="tags-index-subtitle">
                Explora contenido por tecnologia, arquitectura y buenas
                practicas.
              </p>
            </header>

            <div className="tags-index-cloud">
              {group.map((tag) => (
                <Link
                  className="tags-index-chip"
                  key={tag.fieldValue}
                  to={`/tags/${kebabCase(tag.fieldValue)}/`}
                >
                  <span>{tag.fieldValue}</span>
                  <strong>{tag.totalCount}</strong>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);

export default TagsPage;

export const tagPageQuery = graphql`
  query TagsQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(limit: 1000) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`;
